module.exports = __webpack_public_path__ + "static/img/no-result.118e87f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/course/no-result.png
// module id = 7mJN
// module chunks = 0